import {useState, useRef, useEffect} from 'react';
import {setVisibleComponents} from '../omniture-utils';
import {isValidArray} from '@stencil/hotels-utils/src/common-utils';

const useOmnitureVisibleCall = () => {
  const [omniImpressions, setOmniImpressions] = useState<string[]>([]);
  const omniImpressionsLatestValue = useRef<string[] | null>(null);

  //   @Note First UseEffect to overcome to the closure problem and save latest state value on unmount
  useEffect(() => {
    omniImpressionsLatestValue.current = omniImpressions;
  }, [omniImpressions]);

  const pushToOmnitureScroll = () => {
    let holdRefForImpressions = omniImpressionsLatestValue.current as string[];
    if (isValidArray(holdRefForImpressions)) {
      setVisibleComponents(holdRefForImpressions.join(', '));
    }
  };

  useEffect(() => {
    return () => {
      pushToOmnitureScroll();
      setOmniImpressions([]);
    };
  }, []);

  return [setOmniImpressions];
};

export default useOmnitureVisibleCall;
